import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { VerifyingToken } from './components/auth/VerifyingToken';

// Lazy load pages (except VerifyingToken - needs to be eager loaded for auth flow)
const Dashboard = lazy(() => import('./pages/Dashboard'));
const DashboardTest = lazy(() => import('./pages/DashboardTest'));
const Login = lazy(() => import('./pages/Login'));
const Setup = lazy(() => import('./pages/Setup'));
const ProviderKeys = lazy(() => import('./pages/ProviderKeys'));
const ApiKeys = lazy(() => import('./pages/ApiKeys'));
const FleetParity = lazy(() => import('./pages/FleetParity'));
const NotFound = lazy(() => import('./pages/NotFound'));

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
}

export function AppRoutes() {
  console.log('[AppRoutes] Component rendering, current URL:', window.location.href, 'pathname:', window.location.pathname);

  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/verify" element={<VerifyingToken />} />

          {/* Protected routes */}
          <Route
            path="/setup"
            element={
              <ProtectedRoute skipActivationCheck>
                <Setup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard-test"
            element={
              <ProtectedRoute>
                <DashboardTest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-keys"
            element={
              <ProtectedRoute skipActivationCheck>
                <ProviderKeys />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api-keys"
            element={
              <ProtectedRoute skipActivationCheck>
                <ApiKeys />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fleet-parity"
            element={
              <ProtectedRoute skipActivationCheck>
                <FleetParity />
              </ProtectedRoute>
            }
          />

          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
